import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	// const title = node.title;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme, 'theme')

	return {
		"id": id,
		"elements": [{
			"type": "text",
			"id": "EDoYzOANe3",
			"left": 71.97,
			"top": 117.1199675953516,
			"width": 555.7210965435042,
			"height": 139.390625,
			"content": "<p style=\"\"><span style=\"font-size: 79.59px;\"><span style=\"font-family: STSong;\">感谢您的观看</span></span></p>",
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "#333",
			"vertical": false
		},
		{
			"type": "text",
			"id": "kj_LkWTdii",
			"left": 71.97,
			"top": 245.99999999999997,
			"width": 183.253873659118,
			"height": 70.5,
			"content": "<p style=\"\"><span style=\"font-size: 33.67px;\"><span style=\"font-family: STSong;\">THANKS</span></span></p>",
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "#333",
			"vertical": false
		}
		],
		background
	};

}